import { createAsyncThunk } from '@reduxjs/toolkit'

import { ResolveUrl } from 'features/firebase-app'
import { getBearerToken } from '../application/application-slice'
// controller code

export type PublishBrandingArg = {
  brandingId: string
  owner: string
}

export type SetProcessedBrandingReleasedArg = {
  processedBrandingId: string
  released: boolean
  profileOwnerId: string
  owner: string
}

export type DeleteProcessedBrandingReleasedArg = {
  processedBrandingId: string
  owner: string
}

export const PublishBrandingAsync = createAsyncThunk<
  any,
  PublishBrandingArg,
  any
>(
  'composer/brandingController/publish/branding',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('brandingController/publish/branding'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
export const SetProcessedBrandingReleasedAsync = createAsyncThunk<
  any,
  SetProcessedBrandingReleasedArg,
  any
>(
  'composer/brandingController/set/processed/branding/released',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('brandingController/set/processed/branding/released'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
export const DeleteProcessedBrandingReleasedAsync = createAsyncThunk<
  any,
  DeleteProcessedBrandingReleasedArg,
  any
>(
  'composer/brandingController/delete/processed/branding/released',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('brandingController/delete/processed/branding/released'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
